'use strict';

import { promoteAboveTheFoldImages } from './above-the-fold-images.js';

/**
 * Regroupe les optimisations de performance appliquées côté client au chargement.
 * Doit être appelé avant les autres modules pour laisser le navigateur arbitrer
 * le téléchargement des ressources prioritaires (LCP) le plus tôt possible.
 */
export function initPerformance() {
    promoteAboveTheFoldImages();
}
